import styled from "styled-components";

export const Wrapper = styled.div`
  --height: 300px;
  --margin-horizontal: -16px;
  --width: 40%;

  box-sizing: border-box;
  width: 100%;
  height: 0;
  margin: 0 var(--margin-horizontal);
  animation: 250ms slide-out linear;

  &.show {
    margin-top: 10px;
    height: var(--height);
    display: unset;
    animation: 250ms slide-in linear;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    --height: 415px;
    --margin-horizontal: -48px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    --height: 700px;
    --margin-horizontal: 0;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    animation: 250ms width-out linear;
    &.show {
      width: var(--width);
      flex: 0 0 var(--width);
      animation: 250ms width-in linear;
    }
  }

  @keyframes slide-in {
    from {
      height: 0;
    }
    to {
      height: var(--height);
    }
  }

  @keyframes slide-out {
    from {
      height: var(--height);
    }
    to {
      height: 0;
    }
  }

  @keyframes width-in {
    from {
      width: 0;
    }
    to {
      width: var(--width * -1);
    }
  }

  @keyframes width-out {
    from {
      width: var(--width);
    }
    to {
      width: 0;
    }
  }
`;
